import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import { getRequest, patchRequest, postRequest } from '@/plugins/api-axios'

// @ts-ignore
import lodash, { isEmpty } from 'lodash'

import { i18n } from '@/plugins/i18n'

import { languages } from '@/types/languages'

import 'moment-timezone'
import moment from 'moment'
import { openDialog } from '@/_components/dialog/dialog'
import { deserialise, serialise } from 'kitsu-core'

@Mixin
export default class GeneralMixin extends Vue {
    psiBaseUrl = process.env.VUE_APP_PSI_BASE_URL
    authenticationBaseUrl = process.env.VUE_APP_AUTHENTICATION_BASE_URL

    async openDialog(component, props) {
        let res: any = await openDialog(component, props)
        return res
    }

    getURL({ base, path, params }: { path: string; base?: string; params?: Record<string, any> }) {
        let url = new URL(path, base)
        for (let key in params) {
            url.searchParams.append(key, params[key])
        }
        return decodeURIComponent(url.toString())
    }

    getRequestHeaders() {
        return this.headersmixins
    }

    get languageDB() {
        return languages
    }

    get headersmixins() {
        return {
            'Content-Type': 'application/vnd.api+json',
        }
    }

    async getRequest(url: string, params: any) {
        let res = await getRequest(url, this.headersmixins, params)
        return res.data.data
    }

    async generlaGetRequest(url: string, params: Record<string, any>) {
        let res = await getRequest(url, this.headersmixins, params)
        return res.data.data
    }

    async postRequest(url: string, payload: any) {
        let res = await postRequest(url, this.headersmixins, payload)

        return res.data ? deserialise(res.data).data : res
    }

    async getItem(url: string) {
        let res = await getRequest(url, this.headersmixins)

        return res.data ? deserialise(res.data).data : res
    }

    async patch(url: string, headers: any, payload: any, updates?: any) {
        let res = await patchRequest(url, headers, payload.data).catch(async (error) => {
            if (error.data.response.status == 412 && updates) {
                let resNew = await this.getItem(url)
                let changes: Array<any> = []

                Object.keys(updates).map((update: string) => {
                    if (resNew[update] != updates[update]) {
                        changes.push({
                            id: update,
                            fe: updates[update],
                            be: resNew[update],
                        })
                    }
                })

                if (changes.length == 0) {
                    return await this.patch(url, this.headersmixins, payload.data)
                } else {
                    return { isError: true, status: 412, collisions: changes }
                }
            }
        })
        return res.data ? deserialise(res.data).data : res
    }

    get isTouchDevice() {
        return navigator.maxTouchPoints > 0
    }

    getAbbrev(name: string) {
        let abbrev = ''
        name.split(' ').map((item: string) => {
            abbrev = abbrev + item.charAt(0).toUpperCase()
        })
        return abbrev
    }

    getInitials(user: any) {
        let initials = ''
        let name = user.attributes?.name || user.name

        if (!name) return ''

        let words = name.split(/\s/)
        words.map((word, index) => {
            if (index == 0 || index == words.length - 1) {
                initials += word.slice(0, 1).toUpperCase()
            }
        })
        return initials
    }

    getFullName(user: any) {
        return user?.attributes ? user.attributes.name : ''
    }

    filterByProject(items: Record<string, any>, id: string) {
        return Object.values(items).filter((item: any) => {
            return item.relationships.project.data?.id == id
        })
    }

    unflattenArray(items: Array<any>, id: any): Array<any> {
        return items
            .filter((item) => item?.parent?.data?.id === id)
            .map((item) => ({ ...item, children: this.unflattenArray(items, item.id) }))
            .sort((a, b) => (a.index > b.index ? 1 : -1))
    }

    isRichTextEmpty(val: any) {
        let result = true
        if (val) {
            if (this.isJsonString(val)) {
                let parsedVal = JSON.parse(val)
                if (!isEmpty(parsedVal.data)) {
                    result = false
                }
            } else {
                result = false
            }
        }
        return result
    }

    isJsonString(str: string) {
        if (str)
            try {
                JSON.parse(str)
            } catch (e) {
                return false
            }
        return true
    }

    compareRichText(newVal: any, oldVal: any) {
        let res = true

        if (oldVal) {
            if (newVal) {
                if (this.isJsonString(oldVal)) {
                    let newObject = JSON.parse(newVal)
                    let oldObject = JSON.parse(oldVal)

                    if (oldObject.type) {
                        if (oldObject.type == 'text') {
                            res = true
                        } else if (oldObject.type == 'editorjs') {
                            if (lodash.isEqual(newObject.data.blocks, oldObject.data.blocks)) {
                                res = false
                            } else {
                                res = true
                            }
                        }
                    } else {
                        if (lodash.isEqual(newObject.data.blocks, oldObject.blocks)) {
                            res = false
                        } else {
                            res = true
                        }
                    }
                } else {
                    res = true
                }
            } else {
                res = true
            }
        } else {
            if (newVal) {
                res = true
            } else {
                res = false
            }
        }

        return res
    }

    isEqualRichText(newVal: any, oldVal: any) {
        let res = true

        if (oldVal) {
            if (newVal) {
                if (this.isJsonString(oldVal)) {
                    let newObject = JSON.parse(newVal)
                    let oldObject = JSON.parse(oldVal)

                    if (oldObject.type) {
                        if (oldObject.type == 'text') {
                            if (oldObject.data == newObject.data) {
                                res = true
                            } else {
                                res = false
                            }
                        } else if (oldObject.type == 'editorjs') {
                            if (lodash.isEqual(newObject.data.blocks, oldObject.data.blocks)) {
                                res = true
                            } else {
                                res = false
                            }
                        }
                    } else {
                        if (lodash.isEqual(newObject.data.blocks, oldObject.blocks)) {
                            res = true
                        } else {
                            res = false
                        }
                    }
                } else {
                    res = false
                }
            } else {
                res = false
            }
        } else {
            if (newVal) {
                res = false
            } else {
                res = true
            }
        }

        return res
    }

    richTextToString(editor: any) {
        let res = editor

        if (this.isJsonString(editor)) {
            let parsedText = JSON.parse(editor)

            if (parsedText.type) {
                if (parsedText.type == 'text') {
                    res = parsedText.data
                } else if (parsedText.type == 'editorjs') {
                    res = ''
                    parsedText.data.blocks.map((item: any) => {
                        if (item.type == 'paragraph') {
                            res += ' ' + item.data.text
                        } else if (item.type == 'header') {
                            res += ' ' + item.data.text
                        } else if (item.type == 'list') {
                            res += item.data.items.join(' ')
                        }
                    })
                }
            } else {
                res = ''
                parsedText.blocks.map((item: any) => {
                    if (item.type == 'paragraph') {
                        res += ' ' + item.data.text
                    }
                })
            }
        }
        return res
    }

    compareObjects(newVal: any, oldVal: any) {
        return lodash.isEqual(newVal, oldVal)
    }

    // TIME

    generateDate(date: string, format: string) {
        let dateMomentObject = moment(date, format)
        let dateObject: any = dateMomentObject.isValid() ? dateMomentObject.toDate() : false
        return dateObject
    }

    generalFormat(date: any, timeZone?: string, format?: string) {
        return date
            ? timeZone
                ? moment(new Date(date)).tz(timeZone).format(format)
                : moment(new Date(date)).format(format)
            : ''
    }

    durationFormat(date: string, format?: any) {
        return date ? Math.floor(moment.duration(date, format).asHours()) : ''
    }

    formatDateTimeWithTimeZone(date: string, time: string, timeZone: string) {
        return moment.tz(`${date} ${time}`, timeZone ? timeZone : 'Europe/Oslo').format()
    }

    // API
    async getGeneralRequest(url: string) {
        let res = await getRequest(url, this.headersmixins)
        return res.data.data
    }

    async postGeneralRequest(url: string, data?: any) {
        let res = await postRequest(url, this.headersmixins, data)
        return res.data.data
    }

    difference(object, base) {
        function changes(object, base) {
            const diff = lodash.transform(object, function (result: any, value, key: any) {
                if (key === 'type') {
                    // Always include the 'type' attribute
                    result[key] = value
                } else if (base && !lodash.isEqual(value, base[key])) {
                    // Check for differences and recurse if needed
                    result[key] =
                        lodash.isObject(value) && lodash.isObject(base[key])
                            ? changes(value, base[key])
                            : value
                }
            })
            return diff
        }
        return changes(object, base)
    }

    differenceArray(array, base) {
        return lodash.difference(array, base)
    }

    // VUETIFY
    get viewportWidth() {
        return this.$vuetify.breakpoint ? this.$vuetify.breakpoint.width : null
    }

    get viewportHeight() {
        return this.$vuetify.breakpoint ? this.$vuetify.breakpoint.height : null
    }

    get viewType() {
        let result: any = null

        if (this.viewportWidth) {
            switch (true) {
                case this.viewportWidth < 760:
                    result = 'mobile'
                    break
                case this.viewportWidth < 1100:
                    result = 'tablet'
                    break
                case this.viewportWidth < 2000:
                    result = 'default'
                    break
                default:
                    result = 'default'
            }
        }

        return result
    }

    device(size: number) {
        let result: any = null

        if (size) {
            switch (true) {
                case size < 760:
                    result = 'mobile'
                    break
                case size < 1100:
                    result = 'tablet'
                    break
                case size < 2000:
                    result = 'default'
                    break
                default:
                    result = 'default'
            }
        }

        return result
    }

    get dashboardViewType() {
        let result: any = null

        if (this.viewportWidth) {
            switch (true) {
                case this.viewportWidth < 760:
                    result = 'mobile'
                    break
                case this.viewportWidth < 1100:
                    result = 'tablet'
                    break
                case this.viewportWidth < 2000:
                    result = 'default'
                    break
                default:
                    result = 'default'
            }
        }

        return result
    }
}
